import { addRoutes } from 'packages/route'
import { addMenuProvider } from 'packages/web-layout/menu-utils'
import { useContext } from 'react'

import { initUserFeatures, initAdminFeatures } from '../features'

import { SchoolContext } from './context'

/**
 * 初始化features
 *
 * @param hasAnyAdminPermission - 是否有管理权限
 */
export const useInitAdminFeatures = (hasAnyAdminPermission?: boolean) => {
  initAdminFeatures({
    addRoutes,
    addMenuProvider,
    hasAnyAdminPermission,
  })
}

/**
 * 初始化features
 *
 * @returns boolean 插件是否初始化完成
 */
export const useInitUserFeatures = () =>
  initUserFeatures({
    addRoutes,
    addMenuProvider,
  })

/**
 * 获取当前学校 context
 *
 * @returns - 当前学校
 */
export const useSchoolContext = () => {
  const context = useContext(SchoolContext)
  return { ...context }
}
